import { OcapiError } from '../../../../types/ocapi-error';
import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
export var SwapSeatsErrorCodeV1;
(function (SwapSeatsErrorCodeV1) {
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["SwapSeatsNotEnabled"] = 16000] = "SwapSeatsNotEnabled";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["ShowtimeDoesNotHaveAllocatedSeating"] = 16001] = "ShowtimeDoesNotHaveAllocatedSeating";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["OrderHasNoSeats"] = 16002] = "OrderHasNoSeats";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["OrderIncludesPackageTickets"] = 16003] = "OrderIncludesPackageTickets";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["OrderIncludesInSeatDeliveryItems"] = 16004] = "OrderIncludesInSeatDeliveryItems";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["OrderRefunded"] = 16005] = "OrderRefunded";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["SomeSeatsDoNotExist"] = 16006] = "SomeSeatsDoNotExist";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["SomeSeatsInInvalidCategory"] = 16007] = "SomeSeatsInInvalidCategory";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["SomeSeatsUnavailable"] = 16008] = "SomeSeatsUnavailable";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["DuplicateSeats"] = 16009] = "DuplicateSeats";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["ShowtimeEnded"] = 16010] = "ShowtimeEnded";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["OrderBookingModeUnpaid"] = 16011] = "OrderBookingModeUnpaid";
    SwapSeatsErrorCodeV1[SwapSeatsErrorCodeV1["OrderExpired"] = 16300] = "OrderExpired";
})(SwapSeatsErrorCodeV1 || (SwapSeatsErrorCodeV1 = {}));
export class SwapSeatsErrorV1 extends OcapiError {
    constructor(errorCode) {
        const message = `Failed to set subscription item. API error code ${errorCode}: ${SwapSeatsErrorCodeV1[errorCode]}`;
        super(errorCode, message);
    }
}
export async function getSwapSeatsErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(SwapSeatsErrorCodeV1).includes(errorCode)
        ? new SwapSeatsErrorV1(errorCode)
        : error;
}
//# sourceMappingURL=swap-seats-error.js.map